import { addNotification, getSessionSaga, reduceLoading } from 'metrix-common3';
import { call, put } from 'redux-saga/effects';
import { getCancellationSaga } from './getCancellationSaga';

export function* overrideCancellationRefundSaga(action) {
    try {
        yield put(reduceLoading({ code: 'overrideCancellationRefund', value: true }));
        const session = yield getSessionSaga();

        const response = yield call(fetch, '/api/policyCancellation/override-refund', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                policyTransactionGuid: action.payload.policyTransactionGuid,
                refundAmount: action.payload.refundAmount,
            }),
        });

        const result = yield call([response, 'json']);
        yield put(reduceLoading({ code: 'overrideCancellationRefund', value: false }));

        if (result.operation?.status) {
            // Re-read the cancellation so the modal shows the new effective refund amount.
            yield getCancellationSaga({
                payload: {
                    policyTransactionGuid: action.payload.policyTransactionGuid,
                    errorMessage: action.payload.errorMessage,
                },
            });
        } else {
            yield put(
                addNotification({
                    code: 'overrideCancellationRefund',
                    type: 'error',
                    errors: result.operation?.errors,
                    message: action.payload.errorMessage,
                }),
            );
        }
    } catch (error) {
        console.log('Error while overriding Cancellation refund API - ', error);
        yield put(reduceLoading({ code: 'overrideCancellationRefund', value: false }));
        yield put(
            addNotification({
                code: 'overrideCancellationRefund',
                type: 'error',
                message: action.payload.errorMessage,
            }),
        );
    }
}
